require('@fancyapps/fancybox');

const Gallery = function () {

    var initGallery = function () {
        $('[data-fancybox]').fancybox({
            thumbs: {
                autoStart: screen.width > 425,
            },
            buttons: [
                "zoom",
                "share",
                "slideShow",
                "fullScreen",
                "thumbs",
                "close"
            ],
            lang: "hu",
            i18n: {
                hu: {
                    CLOSE: "Bezár",
                    NEXT: "Következő",
                    PREV: "Előző",
                    ERROR: "A kért tartalom nem tölthető be.",
                    PLAY_START: "Diavetítés indítása",
                    PLAY_STOP: "Diavetítés szüneteltetése",
                    FULL_SCREEN: "Teljes képernyő",
                    THUMBS: "Képek",
                    DOWNLOAD: "Letöltés",
                    SHARE: "Megosztás",
                    ZOOM: "Nagyítás"
                },
            }
        });
    };

    return {
        init: function () {
            initGallery();
        }
    };
}();

$(document).ready(function () {
    Gallery.init();
});
